import { Box, Typography } from '@mui/material';
import { LabelsInput } from '@ragu-components/ord-components';
import { Resources } from '@ragu-components/ord-resources';
import { useGetList, useGetRecordId, useTranslate } from 'react-admin';
import { Link } from 'react-router-dom';

import type { RoleRead } from '@ragu-components/ord-types';
import type { InputProps } from 'react-admin';

export const UserAclLabelsInput = (props: InputProps): React.ReactElement => {
  const id = useGetRecordId();
  const translate = useTranslate();

  const { data: roles } = useGetList<Required<RoleRead>>(Resources.roles, {
    filter: { active: 'fiql', fiql: `users.id==${id}` },
  });

  const inheritedFrom = (roles ?? []).filter((role) => role.acl_labels.length > 0);

  return (
    <>
      {inheritedFrom.length > 0 && (
        <Typography variant='subtitle2' sx={{ fontWeight: 'bold', mb: 1 }}>
          <Box display='flex' gap={1}>
            {translate('ord.permissions.inheritedAclLabelsDescription')}
            {`: `}
            {inheritedFrom.map(({ id, name }) => (
              <Link key={id} to={`/${Resources.roles}/${id}`}>
                {name}
              </Link>
            ))}
          </Box>
        </Typography>
      )}
      <LabelsInput filter={{ meta: { sorting: { sort: { field: 'name', order: 'ASC' } } } }} {...props} />
    </>
  );
};
